/*import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;*/

import React, { Component } from 'react';
import {HashRouter, Redirect, Route, Switch, BrowserRouter} from 'react-router-dom';
import './scss/style.scss';
import {MainFooter} from "./views/containers";
import MainHeader from "./views/containers/MainHeader";
import routes from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {useTranslation} from "react-i18next";

const loading = (
    <div>
        <div className="d-lg-block d-md-block d-sm-none d-none"><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></div>
        <div className="d-lg-none d-md-none d-sm-block d-block"><br/><br/><br/><br/><br/><br/><br/></div>
        <div className="spinner-border text-primary  justify-content-center align-content-center mx-auto" role="status">
            <span className="sr-only">Chargement...</span>
        </div>
        <div className="d-lg-block d-md-block d-sm-none d-none"><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/></div>
        <div className="d-lg-none d-md-none d-sm-block d-block"><br/><br/><br/><br/><br/><br/><br/></div>
    </div>
);

const MainLayout = React.lazy(() => import('./views/containers/MainLayout'));

// Pages
// const Login = React.lazy(() => import('./views/pages/login/Login'));
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));


class App extends Component {

  render() {
    return (
        <BrowserRouter>
          <React.Suspense fallback={loading}>
              {/*<Route path="/" name="Home" render={props => <MainLayout {...props}/>} />*/}

              <MainHeader/>
              <React.Suspense fallback={loading}>
                  <Switch>
                      {routes.map((route, idx) => {
                          return route.component && (
                              <Route
                                  key={idx}
                                  path={route.path}
                                  exact={route.exact}
                                  name={route.name}
                                  render={props => (
                                      <route.component {...props} />
                                  )} />
                          );
                      })}
                      <Redirect from="/" to="/" />
                  </Switch>
              </React.Suspense>
              <MainFooter/>
              <ToastContainer
                  position="top-right"
                  autoClose={6000}
                  hideProgressBar={true}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover/>
          </React.Suspense>
        </BrowserRouter>
    );
  }
}

export default App;
